import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CountryCodesData } from '../../../../data/portal-master-data';
import { LovDataService } from '../../../../services/lov-data.service';

@Component({
  selector: 'form-mobile-no',
  templateUrl: './form-mobile-no.component.html',
  styleUrls: ['./form-mobile-no.component.scss'],
})
export class FormMobileNoComponent implements OnInit, OnChanges {
  @Input() label;
  @Input() help;
  @Input() controls: any[];
  @Input() showErrors: Boolean;
  @Input() enableExtension: Boolean;
  @Input() placeholder;
  @Input() crmExist;
  @Input() pendingApproval;
  @Input() pendingApprovalCountryCode;
  @Input() pendingApprovalExt;
  @Input() location;
  @Input() enableDiv;
  @Input() mobileVerifyTick;
  @Input() faxExtension;
  @Input() optionalSameLine;
  @Input() optionalSeparateLine;

  data = CountryCodesData.filter((i) => i.id).map((i) => {
    return {
      id: i.id,
      text: `
        ${i.name} (${i.id})
      `,
    };
  });
  phoneInputForm: FormGroup;
  justValuesChanged;

  constructor(private lovDataService: LovDataService, private fb: FormBuilder) {
    this.phoneInputForm = this.fb.group({
      countryCode: [],
      number: [],
      extension: [],
    });
  }

  ngOnInit() {
    this.phoneInputForm.valueChanges.subscribe((value) => {
      if (this.justValuesChanged) {
        this.justValuesChanged = false;
        return;
      }
      this.controls[0].setValue(value.countryCode);
      this.controls[1].setValue(value.number && value.number.substring(0, 3));
      this.controls[2].setValue(value.number && value.number.substring(3));
      if (this.controls[3]) {
        this.enableExtension = true;
        this.controls[3].setValue(value.extension);
      }
    });
  }

  ngOnChanges(changes) {
    if (changes['pendingApprovalCountryCode'] && this.pendingApprovalCountryCode) {
      this.pendingApproval = `${(this.pendingApprovalCountryCode && this.pendingApprovalCountryCode + ' ') || ''}${this.pendingApproval}`;
    }
    if (changes['pendingApprovalExt'] && this.pendingApprovalExt) {
      this.pendingApproval = `${(this.pendingApproval && this.pendingApproval) || ''}${(this.pendingApprovalExt && ' / ' + this.pendingApprovalExt) || ''
        }`;
    }

    if (changes['controls'] && this.controls) {
      this.phoneInputForm.get('countryCode').setValue(this.controls[0].value || this.data.find((i) => i.id === '94'));
      this.phoneInputForm.get('number').setValue(`${this.controls[1].value || ''}${this.controls[2].value || ''}`);
      if (this.crmExist) {
        this.phoneInputForm.get('countryCode').disable();
        this.phoneInputForm.get('number').disable();
      }
      if (this.controls[3]) {
        this.enableExtension = true;
        this.phoneInputForm.get('extension').setValue(this.controls[3].value);
      }
      this.justValuesChanged = true;
      setTimeout(() => {
        this.justValuesChanged = false;
      }, 500);
    }
  }
}
